"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.renderCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../../utils/helpers");

var _Card = require("./Card");

var _Portrait = _interopRequireDefault(require("../Portrait"));

var variants = {
  article: _Card.CardArticle,
  list: _Card.CardList,
  product: _Card.CardProduct,
  detailedProfile: _Card.CardProfile,
  signpost: _Card.CardSignpost,
  signpostText: _Card.CardSignpostText
};

var renderCard = function renderCard(card, variant, cardsPerRow) {
  var Card = (0, _helpers.getObjectProperty)(variants, variant, 'product');

  if (variant === 'profile') {
    return /*#__PURE__*/_react.default.createElement(_Portrait.default, {
      company: card.company,
      jobTitle: card.jobTitle,
      image: card.image,
      name: card.name,
      link: card.link
    });
  }

  if (variant === 'detailedProfile') {
    return /*#__PURE__*/_react.default.createElement(Card, card);
  }

  return /*#__PURE__*/_react.default.createElement(Card, {
    badge: card.badge,
    banner: card.banner,
    copy: card.copy,
    cta: card.cta,
    secondaryCta: card.secondaryCta,
    image: card.image,
    imageSize: cardsPerRow === 2 ? 'large' : 'small',
    label: card.label,
    link: card.link,
    price: card.price,
    title: card.title,
    subtitle: card.subtitle,
    description: card.description,
    date: card.date,
    tag: card.tag,
    variant: variant,
    cardsPerRow: cardsPerRow,
    bookmark: card.bookmark,
    onClickLabel: card.onClickLabel,
    tags: card.tags,
    tagsLabel: card.tagsLabel
  });
};

exports.renderCard = renderCard;
var _default = renderCard;
exports.default = _default;